"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaylistForAdminEntity = exports.MediaPlaylistForAdminEntity = void 0;
const media_1 = require("../media");
class MediaPlaylistForAdminEntity extends media_1.MediaForAdminEntity {
    block;
    isLastMedia;
    mediaCampaignId;
    playlistId;
    // Esta duracion es el resultado de la duracion del media expresado en bloques
    identifier;
    mediaDuration;
    hours;
}
exports.MediaPlaylistForAdminEntity = MediaPlaylistForAdminEntity;
class PlaylistForAdminEntity {
    _id;
    id;
    medias;
    is_on;
    is_archive;
    date;
    display;
    updatedAt;
    createdAt;
}
exports.PlaylistForAdminEntity = PlaylistForAdminEntity;
